// extracted by mini-css-extract-plugin
export default {"footer":"-MwjKWYYLh7l1bTYUadD3A==","secureCaption":"siAS2oqensZqnAw18InYng==","qontoLogo":"l+8BozBgkwkxgA8kmF7oNQ=="};